import * as React from 'react';
import { Component, deps, inject, observer } from '../../lib/component';
import { AddThisShareBox } from '../social/add-this-share-box';

export interface FollowCompatProps {

}

@inject(deps) @observer
export class FollowCompat extends Component<FollowCompatProps> {
  render() {
    return (
      <AddThisShareBox follow={true} />
    )
  }
}